import React from 'react';
import { useSearchParams } from 'react-router-dom';
import PageLayout from '@components/layout/PageLayout';
import EstimationFactorDetails from '@components/estimation-factor-details/EstimationFactorDetails';
import useSession from '@hooks/useSession';

const EstimationFactorDetailsPage = () => {
  const [searchParams] = useSearchParams();
  const { isAdmin, isSuperAdmin } = useSession();
  // Approver (Windvoice.Approver) has read-only access — no editing actions
  const isReadOnly = isAdmin && !isSuperAdmin;

  const energyType = searchParams.get('energyType') || '';
  const region = searchParams.get('region') || '';
  const month = searchParams.get('month') || '';

  return (
    <PageLayout title="Estimation Factor Dashboard">
      <EstimationFactorDetails
        energyType={energyType}
        region={region}
        month={month}
        readOnly={isReadOnly}
      />
    </PageLayout>
  );
};

export default EstimationFactorDetailsPage;
